export default __webpack_public_path__ + "static/media/dudas.9c526063.png";